import { render, staticRenderFns } from "./UserBridgeAssociation.vue?vue&type=template&id=10eb1cfe&scoped=true"
import script from "./UserBridgeAssociation.vue?vue&type=script&lang=js"
export * from "./UserBridgeAssociation.vue?vue&type=script&lang=js"
import style0 from "./UserBridgeAssociation.vue?vue&type=style&index=0&id=10eb1cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb1cfe",
  null
  
)

export default component.exports